import { AxiosError, AxiosResponse } from 'axios';
import { ErrorType } from '../types/commonTypes';
import { getStringFromObject } from './lodash';
import { isObjectValidAndNotEmpty } from './nullChecks';

export const userNotLoggedInMessage = 'User not logged in..';

export const versionMisMatchErrorMessage = 'App Version Has Been Updated. Please Refresh To Access The Latest Version.';

export const didApiCallFailDueToUnauthorizedUser = (error: AxiosError<ErrorType>) => (
    error &&
    (error.status === 401 ||
        (error.response && error.response.status === 401) ||
        (error.response && getStringFromObject('response.message', error) === userNotLoggedInMessage) ||
        (error.response && error.response.data &&
            error.response.data.exception === userNotLoggedInMessage
        )
    )
);

export const getErrorMessage = (error: AxiosError<ErrorType>) => {
    const { response } = error;
    let errorMessage = 'Api Call Failed';
    if (isObjectValidAndNotEmpty<AxiosResponse<ErrorType, unknown>>(response)) {
        errorMessage = response.data?.exception || response.data?.message || errorMessage;
        if (response?.status === 401) {
            errorMessage = 'Session Timed Out. Please Login Again';
        }
        if (response.status === 426) {
            errorMessage = versionMisMatchErrorMessage;
        }
    }
    return errorMessage;
};

export const didApiCallFailDueToVersionMismatch = (error: AxiosError<ErrorType>) => (
    error &&
    (error.status === 426 ||
        (error.response && error.response.status === 426) ||
        (error.response && getStringFromObject('response.message', error) === versionMisMatchErrorMessage) ||
        (error.response && error.response.data &&
            error.response.data.exception === versionMisMatchErrorMessage
        )
    )
);
